import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { faMusic as solidFaMusic } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import type { Pathname } from '@components/main-components/link/AccessibleLink';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { DropdownMenuItem, MenuItemLabel } from '../GlobalDropdown';

export const ViewSongMenuItem = ({
  variant = 'regular',
  href,
}: {
  variant?: 'regular' | 'solid';
  href: Pathname;
}) => {
  const icon = variant === 'regular' ? faMusic : solidFaMusic;
  return (
    <AccessibleLink pathnameUri={href}>
      <DropdownMenuItem>
        <FontAwesomeIcon icon={icon} size="lg" />
        <MenuItemLabel>View song</MenuItemLabel>
      </DropdownMenuItem>
    </AccessibleLink>
  );
};
